export default __webpack_public_path__ + "static/media/Eva 9781408312995.c99f8912.jpg";